import { render, staticRenderFns } from "./PopupRiskInfoBsgs2.vue?vue&type=template&id=61e6e8de&scoped=true&"
import script from "./PopupRiskInfoBsgs2.vue?vue&type=script&lang=js&"
export * from "./PopupRiskInfoBsgs2.vue?vue&type=script&lang=js&"
import style0 from "./PopupRiskInfoBsgs2.vue?vue&type=style&index=0&id=61e6e8de&prod&lang=scss&scoped=true&"
import style1 from "./PopupRiskInfoBsgs2.vue?vue&type=style&index=1&id=61e6e8de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e6e8de",
  null
  
)

export default component.exports